import util from '@/script/util';
import i18n from '@/i18n';

const dateTime = val => {
  const d = new Date(val);
  const year = d.getFullYear();
  const month = d.getMonth();
  const date = d.getDate();
  const hour = d.getHours();
  const minutes = d.getMinutes();
  const seconds = d.getSeconds();
  const unit = hour >= 12 ? 'PM' : 'AM';
  const monthes = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  return {
    year,
    month: util.repaireZero(month + 1),
    fullMonthStr: monthes[month],
    simpleMonthStr: monthes[month].slice(0, 3),
    date: util.repaireZero(date),
    hour: util.repaireZero(hour),
    minutes: util.repaireZero(minutes),
    seconds: util.repaireZero(seconds),
    unit
  };
};

const dateYMD = val => {
  const d = dateTime(val);
  return `${d.simpleMonthStr} ${d.date}, ${d.year}`;
};

const dateHM = val => {
  const d = dateTime(val);
  return `${d.hour}:${d.minutes} ${d.unit}`;
};

export function translateDateYMD(val) {
  return dateYMD(val);
}

export function translateDateHM(val) {
  return dateHM(val);
}

export function translateDate(val) {
  if (!val) return '';
  val *= 1;
  return `${translateDateHM(val)}, ${translateDateYMD(val)}`;
}

export function translateDateZh(val) {
  if (!val) return '';
  val *= 1;
  const d = dateTime(val);
  return `${d.year}-${d.month}-${d.date} ${d.hour}:${d.minutes}:${d.seconds}`;
}

export function translateDateSimpleZh(val) {
  if (!val) return '';
  val *= 1;
  const d = dateTime(val);
  return `${d.year}-${d.month}-${d.date} ${d.hour}:${d.minutes}`;
}

/**
 * @description 将数字转换成K为单位的字符
 * @param {Number} val
 * @returns {String}
 * 23 => 23
 * 1122 => 1.1K
 */
export function thousandsTranslate(val = 0) {
  if (!/^\d+$/.test(val)) return val;
  if (val < 1000) return val;
  const th = Math.floor(val / 1000) * 100;
  const decimal = Math.round((val % 1000) / 10);
  return (th + decimal) / 100 + 'K';
}

/**
 * @description 分類名稱過濾
 */
export function gameCategoryName(type) {
  switch (type) {
    case 'PC':
      return i18n.t('skill_add5');
    case 'PHONE':
      return i18n.t('mbgame');
    case 'CONSOLE':
      return i18n.t('skill_add6');
    case 'VOICE':
      return i18n.t('skill_add7');
    case 'OTHER':
      return i18n.t('skill_add8');
    default:
      return '';
  }
}

/**
 * @description 将订单状态转换称业务文案，首字母小写
 * @param {String} status 订单状态
 * @param {String} prefix 是否将Finished状态转换称Complete文案
 * @returns {String}
 */
export function orderProgressStatusTranslate(
  status,
  preStatus = '',
  prefix = 'You'
) {
  if (!status) return status;
  if (status === 'Processing' && preStatus === 'Effective') {
    return (
      prefix +
      (prefix === 'You' ? ' accepted the order' : ' accepted your order')
    );
  }
  if (status === 'Invalid' && preStatus === 'Effective') {
    return prefix + ' canceled the order';
  }
  const map = {
    Effective: 'placed the order',
    Processing: 'accepted your order',
    Arbitrated: 'dispute resolved',
    Controversy: 'cancellation request',
    Negotiate: 'in dispute',
    Arbitration: 'in dispute',
    Finished: prefix ? 'completed' : 'write a review',
    Invalid: 'canceled',
    completed: 'completed'
  };
  return map[status] || status;
}

/**
 * @description 将订单状态转换称业务文案，首字母大写
 * @param {String} status 订单状态
 * @param {Boolean} finishedToComplete 是否将Finished状态转换称Complete文案
 * @returns {String}
 */
export function orderStatusTranslateUpperCase(
  status,
  finishedToComplete = true,
  refundType
) {
  if (!status) return status;
  const map = {
    UnCreated: i18n.t('orderdetail_5'),
    Effective: i18n.t('order_Confirming'),
    Processing: i18n.t('order_inProgress'),
    Controversy: i18n.t('refund_application_in_progress'),
    Negotiate: finishedToComplete
      ? i18n.t('already_refused_refund')
      : i18n.t('refund_application_has_been_rejected'),
    Created: i18n.t('pending_payment'),
    Arbitration: i18n.t('refund_application_in_progress'),
    Arbitrating: i18n.t('refund_application_in_progress'),
    Arbitrated: i18n.t('refund_application_in_progress'),
    Finished: i18n.t('already_completed'),
    Invalid:
      refundType === 'FULL'
        ? i18n.t('refund_completed')
        : i18n.t('orderdetail_2'),
    Completed: i18n.t('pending_evaluation'),
    PlayerConfirm: i18n.t('boosting_coach_confirmed_completion'),
    REFUND_SUCCESS: i18n.t('refund_completed')
  };
  return map[status] || status;
}

export function salesUnitTranslate(salesUnit, hack = false) {
  if (!salesUnit) return salesUnit;
  const map = {
    HalfHour: i18n.t('30_minutes'),
    Hour: i18n.t('hour'),
    Game: i18n.t('round'),
    game: i18n.t('round'),
    h: i18n.t('hour'),
    Time: i18n.t('times'),
    win: i18n.t('victory'),
    Day: i18n.t('days'),
    Minutes7: i18n.t('7_minutes')
  };
  return (
    (hack ? (salesUnit !== 'HalfHour' ? 1 : '') : '') + map[salesUnit] ||
    salesUnit
  );
}

export function parseGameMode(code) {
  const rs = util.gameModelColumn.find(item => item.value === code);
  return rs ? rs.text : code;
}

export function RoundingFilter(value) {
  if (!value) return value;
  return parseFloat(value).toFixed(1);
}
// 订单信息
export function orderInfoTranslate(
  info,
  controler = [
    'gameName',
    'gameModelName',
    'gameQuickMatchLevels',
    'sex',
    'budgetAmountRight'
  ]
) {
  const {
    gameName,
    gameModelName,
    gameQuickMatchLevels,
    sex,
    currencyKind,
    budgetAmountRight,
    salesUnit,
    count,
    extraInfo
  } = info;
  const result = [];
  if (gameName && controler.includes('gameName')) {
    result.push(gameName);
  }
  if (extraInfo) {
    const extraJson = JSON.parse(extraInfo);
    if (extraJson) {
      const { currentSelectTime } = extraJson;
      if (currentSelectTime) {
        result.push(currentSelectTime);
      }
    }
  }
  if (gameModelName && controler.includes('gameModelName')) {
    result.push(
      gameModelName === i18n.t('no_restrictions')
        ? i18n.t('mode_unlimited')
        : gameModelName
    );
  }
  if (gameQuickMatchLevels && controler.includes('gameQuickMatchLevels')) {
    result.push(
      gameQuickMatchLevels === i18n.t('no_restrictions')
        ? i18n.t('rank_no_restriction')
        : gameQuickMatchLevels
    );
  }
  if (sex && controler.includes('sex')) {
    const filter = {
      Male: i18n.t('gamelol_male'),
      Female: i18n.t('gamelol_female')
    };
    result.push(filter[sex] || i18n.t('myorder_sex'));
  }
  if (controler.includes('experience') && info.experience) {
    result.push(i18n.t('experience_order'));
    return result.join('，');
  }
  if (budgetAmountRight && controler.includes('budgetAmountRight')) {
    let str = '';
    if (+budgetAmountRight === 999999) {
      str += i18n.t('myorder_price') + '  ';
    } else {
      str += ` ${'$' || currencyKind}${budgetAmountRight}/`;
    }
    str += `${salesUnitTranslate(salesUnit)}*${count}`;
    result.push(str);
  }
  return result.join('，');
}

/**
 * @param {string} format 格式
 * @param {int} timestamp 要格式化的时间 默认为当前时间
 * @return {string}   格式化的时间字符串
 */
export function tuiFormartDate(mss) {
  var hours = parseInt(mss / (1000 * 60 * 60));
  var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
  return `${hours} ${i18n.t('hours')} ${minutes} ${i18n.t('minutes')} `;
}

/**
 * @description 退款申請詳情 将订单状态转换称业务文案
 * @param {String} status 订单状态
 * @returns {String}
 */
export function tuiCorderStatus(status) {
  if (!status) return status;

  const map = {
    Controversy: i18n.t('h5_refund_no_reply_auto_refund'),
    Negotiate: i18n.t('h5_refund_negotiate_tip')
  };

  return map[status] || status;
}
/**
 * @description 退款詳情 将拒绝信息转换称业务文案
 * @param {String} rejectReason 拒绝原因
 * @returns {String}
 */
export function tuiRejectReason(rejectReason) {
  if (!rejectReason) return rejectReason;
  const reasonList = {
    COMPLETED: i18n.t('h5_refund_reason_completed'),
    USER_MALICIOUS_REFUND: i18n.t('h5_refund_reason_malicious'),
    OTHER: i18n.t('other')
  };
  return reasonList[rejectReason] || rejectReason;
}
/**
 * @description 动态详情 将发布时间转换称业务文案
 * @param {String} 发布时间戳 endTime
 * @returns {String}
 */
export function formDataTimeFeed(endTime) {
  if (!endTime) return;
  const startTime = new Date().getTime();
  const timeStamp = startTime - endTime;
  let valString = '';
  if (timeStamp < 5 * 60 * 1000) {
    valString = i18n.t('status_just');
  } else if (timeStamp < 60 * 60 * 1000) {
    const timeMinutes = parseInt(timeStamp / (1000 * 60));
    valString = `${timeMinutes}${i18n.t('minutes_ago')}`;
  } else if (timeStamp < 24 * 60 * 60 * 1000) {
    const timeHours = parseInt(timeStamp / (1000 * 60 * 60));
    valString = `${timeHours}${i18n.t('hours_ago')}`;
  } else if (
    timeStamp >= 24 * 60 * 60 * 1000 &&
    timeStamp < 7 * 24 * 60 * 60 * 1000
  ) {
    const timeDay = parseInt(timeStamp / (24 * 60 * 60 * 1000));
    valString = `${i18n.t('msg_days_ago', { msg: timeDay })}`;
  } else {
    valString = new Date(endTime).$format('yyyy-MM-dd');
  }
  return valString;
}

/**
 * @description: 用户等级文案
 * @param {*}
 * @return {*}
 */
export function getUserlevel(level) {
  if (!level) return i18n.t('level_normal');
  if (level < 6) return i18n.t('gold_membership');
  if (level < 11) return i18n.t('diamond_member');
  if (level < 13) return i18n.t('black_gold_member');
  if (level > 12) return i18n.t('legendary_member');
}
/**
 * @description: 用户等级文案
 * @param {*}
 * @return {*}
 */
export function getUserlevel2(level) {
  if (!level) return i18n.t('normal');
  if (level < 6) return i18n.t('gold');
  if (level < 11) return i18n.t('gamelol_diamond');
  if (level < 13) return i18n.t('black_gold');
  if (level > 12) return i18n.t('legendary');
}

/**
 * @description: 用户等级顏色
 * @param {*}
 * @return {*}
 */
export function getUserlevelColor(level) {
  if (!level) return '#535C65';
  if (level < 6) return '#B2853E';
  if (level < 11) return '#8456C9';
  if (level > 10) return '#68243A';
}

/**
 * @description: 用户权益
 * @param {*}
 * @return {*}
 */
export function getUserPrivilege(currentCard) {
  const vip = (key, params) => i18n.t(`h5_vip_${key}`, params);
  const outfit = src => ({
    title: vip('member_outfit_permanent'),
    remark: vip('member_outfit_remark'),
    src
  });
  const coupon = (count, amount, src) => ({
    title: vip('coupon_title', { count, amount }),
    remark: vip('monthly_claim_all'),
    src
  });
  const diamonds = amount => ({
    title: vip('diamond_title', { amount }),
    remark: vip('monthly_claim'),
    src: require('@/assets/image/icons/diamond.png')
  });
  const avatarFrame = (name, src) => ({
    title: vip('avatar_frame', { name }),
    remark: '',
    src
  });
  const mount = (name, src, permanent = false, noble = false) => ({
    title: vip(permanent ? 'mount_permanent' : 'mount', { name }),
    remark: vip(noble ? 'voice_room_noble_enter' : 'voice_room_enter'),
    src
  });
  const levelGift = (name, hours, src, cover = false, unlock = true) => ({
    title: vip(unlock ? 'unlock_level_gift' : 'level_gift', { name }),
    remark: vip(cover ? 'app_cover_hours' : 'home_recommend_hours', { hours }),
    src
  });
  const exclusiveFrame = (name, giftName, src) => ({
    title: vip('exclusive_frame', { name }),
    remark: vip('gift_both_get', { name: giftName }),
    src
  });
  const beautifulId = (digits) => ({
    title: vip('beautiful_id', { digits }),
    remark: '',
    src: 'https://resource.funplus.social/icon/beautiful-account-uuid.png'
  });
  const needPoints = points => vip('need_points', { points });
  const itemName = key => vip(`item_${key}`);

  if (currentCard == 0) {
    return [
      {
        level: 1,
        levelName: 'VIP1',
        list: [
          outfit(
            'https://resource.funplus.social/user-static/cc35f6d8-3228-48a8-a6c6-9796070b3adf1123446027332737724.png'
          )
        ],
        contents: []
      },
      {
        level: 2,
        levelName: 'VIP2',
        list: [
          outfit(
            'https://resource.funplus.social/user-static/42876e1c-5a13-4932-b6c1-e66e153cccde3917384102538674185.png'
          )
        ],
        contents: []
      },
      {
        level: 3,
        levelName: 'VIP3',
        list: [
          outfit(
            'https://resource.funplus.social/user-static/3ffe4926-5d69-41c6-8e6d-049f6cd78de83388470595401218205.png'
          )
        ],
        contents: []
      },
      {
        level: 4,
        levelName: 'VIP4',
        list: [
          outfit(
            'https://resource.funplus.social/user-static/d6ccfc1b-234d-4324-91c0-8c54c743b3458870321603918141904.png'
          ),
          coupon(1, 10, require('@/pages/vip-center/images/vouchers10.png'))
        ],
        contents: [needPoints(1688)]
      },
      {
        level: 5,
        levelName: 'VIP5',
        list: [
          outfit(
            'https://resource.funplus.social/user-static/561d1cc8-06c3-4a12-a20b-738e9912cad26747758172681581216.png'
          ),
          coupon(1, 15, require('@/pages/vip-center/images/vouchers15.png'))
        ],
        contents: [needPoints(2888)]
      }
    ];
  }
  if (currentCard == 1) {
    return [
      {
        level: 6,
        levelName: 'VIP6',
        list: [
          outfit(
            'https://resource.funplus.social/user-static/55f5ae32-51d2-4051-bc80-7c4b8ebb8cfd8265352842262970098.png'
          ),
          coupon(2, 20, require('@/pages/vip-center/images/vouchers202.png'))
        ],
        contents: [needPoints(5888)]
      },
      {
        level: 7,
        levelName: 'VIP7',
        list: [
          outfit(
            'https://resource.funplus.social/user-static/09e62b3f-516a-49ae-86ad-bff7241fa8301879889190588913679.png'
          ),
          coupon(5, 20, require('@/pages/vip-center/images/vouchers205.png'))
        ],
        contents: [needPoints(10888)]
      },
      {
        level: 8,
        levelName: 'VIP8',
        list: [
          outfit(
            'https://resource.funplus.social/user-static/78c7680b-4e52-4d29-8d46-4790a2d1db04826041686437768312.png'
          ),
          coupon(5, 40, require('@/pages/vip-center/images/vouchers405.png')),
          avatarFrame(
            itemName('qili_fire'),
            'https://resource.3uplay.com/sys-feed/7ad23dcd-6e89-4d5f-8b3b-19c93504399162458071860111974.webp'
          )
        ],
        contents: [needPoints(18888)]
      },
      {
        level: 9,
        levelName: 'VIP9',
        list: [
          outfit(
            'https://resource.funplus.social/user-static/1473103e-04e9-4d28-8a7b-6cbea07a09335872199161878626306.png'
          ),
          coupon(6, 50, require('@/pages/vip-center/images/vouchers506.png')),
          diamonds(1000),
          avatarFrame(
            itemName('bright_stars'),
            'https://resource.3uplay.com/sys-feed/1ab0e7e5-4c88-44e1-b145-6f0b476a97765043400655333806831.webp'
          ),
          mount(
            itemName('dream_car'),
            'https://resource.funplus.social/sys-feed/vip10mount.png'
          )
        ],
        contents: [needPoints(32888)]
      },
      {
        level: 10,
        levelName: 'VIP10',
        list: [
          outfit(
            'https://resource.funplus.social/user-static/7ae5ea64-bd0e-4581-9aff-c043a8a005055301247670341822606.png'
          ),
          coupon(10, 50, require('@/pages/vip-center/images/vouchers5010.png')),
          diamonds(2000),
          avatarFrame(
            itemName('white_tiger'),
            'https://resource.3uplay.com/sys-feed/e55a0ad8-cc3d-4c25-ab61-701a0db0506b2942692824599419797.webp'
          ),
          mount(
            itemName('extreme_car'),
            'https://resource.3uplay.com/user-static/b5fcd9fa-037a-4413-9302-22fd334671ad829868178297944366.png'
          ),
          levelGift(
            itemName('romantic_firework'),
            3,
            'https://resource.funplus.social/user-static/ce027ebd-d55c-4d9c-83fa-d0864e1c76244602803198104592251.png'
          )
        ],
        contents: [needPoints(58888)]
      }
    ];
  }
  if (currentCard == 2) {
    return [
      {
        level: 11,
        levelName: 'VIP11',
        list: [
          outfit(
            'https://resource.funplus.social/user-static/45a4eb82-a223-4a95-abc0-744f27d16b475713656407318892648.png'
          ),
          coupon(10, 100, require('@/pages/vip-center/images/vouchers10010.png')),
          diamonds(3000),
          avatarFrame(
            itemName('qilin'),
            'https://resource.3uplay.com/sys-feed/f380bbc0-7524-4ef1-997b-22147514aa4a8681103701677371083.webp'
          ),
          mount(
            itemName('white_tiger'),
            'https://resource.3uplay.com/user-static/528a63f8-aa6e-4e61-a9a4-a2b71cb321474313932241586712510.png',
            true
          ),
          levelGift(
            itemName('moved_for_you'),
            6,
            'https://resource.funplus.social/user-static/d5ed48b4-22b7-4889-ad23-e87531663d3b215121112193972884.png'
          )
        ],
        contents: [needPoints(108888)]
      },
      {
        level: 12,
        levelName: 'VIP12',
        list: [
          outfit(
            'https://resource.funplus.social/user-static/cdc30821-3913-42a7-a468-564cf1c026da6295698306921076813.png'
          ),
          coupon(10, 150, require('@/pages/vip-center/images/vouchers15010.png')),
          diamonds(5000),
          avatarFrame(
            itemName('crystal_shine'),
            'https://resource.3uplay.com/sys-feed/48014152-7173-4e8b-9ed0-dcf80b4603167898124707431348557.webp'
          ),
          mount(
            itemName('qilin'),
            'https://resource.3uplay.com/user-static/d2ff59d0-70d8-480a-9e63-1c17774817e4339078782096881481.png',
            true
          ),
          levelGift(
            itemName('pyramid'),
            12,
            'https://resource.3uplay.com/user-static/cda5c90c-d4a1-4646-8348-ff54219b812f6783784607361150213.png',
            false,
            false
          ),
          exclusiveFrame(
            itemName('qilin'),
            itemName('pyramid'),
            'https://resource.funplus.social/sys-feed/cbf45522-9c6c-4ec5-b6db-a9701bf844924779238591151154335.webp'
          )
        ],
        contents: [needPoints(188888)]
      }
    ];
  }
  if (currentCard == 3) {
    return [
      {
        level: 13,
        levelName: 'VIP13',
        list: [
          outfit(
            'https://resource.funplus.social/user-static/2fbe29ac-23c4-4d9f-a76a-fc634ea59ade2103908576236737035.png'
          ),
          coupon(10, 200, require('@/pages/vip-center/images/vouchers20010.png')),
          diamonds(10000),
          avatarFrame(
            itemName('legend'),
            'https://resource.3uplay.com/sys-feed/54594ada-50ab-4c50-aec3-73442f8569d26998679258403359771.webp'
          ),
          mount(
            itemName('phoenix'),
            'https://resource.funplus.social/user-static/5599e8fc-91c8-4929-b72a-fdc6d65e099c2211960911304977854.png',
            true
          ),
          levelGift(
            itemName('sky_city'),
            6,
            'https://resource.3uplay.com/user-static/d442c7a3-9c45-42e0-afc1-973ab87be0e69012342766309652403.png',
            true
          ),
          exclusiveFrame(
            itemName('legend_phoenix'),
            itemName('sky_city'),
            'https://resource.funplus.social/sys-feed/746410f7-2887-4ce6-b7bb-fc95bf46abaa4026451898564482081.webp'
          ),
          beautifulId(6),
          {
            title: vip('permanent_custom_frame'),
            remark: '',
            src: 'https://resource.funplus.social/icon/exclusive-headframe.png'
          }
        ],
        contents: [needPoints(388888)]
      },
      {
        level: 14,
        levelName: 'VIP14',
        list: [
          outfit(
            'https://resource.funplus.social/user-static/43d58099-d952-4136-a0f6-2ca6c88994051962669988220948509.png'
          ),
          coupon(10, 200, require('@/pages/vip-center/images/vouchers20010.png')),
          diamonds(50000),
          avatarFrame(
            itemName('king_legend'),
            'https://resource.3uplay.com/sys-feed/72b8b495-5b20-486d-87db-85c788bc623d4618690156184238774.webp'
          ),
          mount(
            itemName('dragon'),
            'https://resource.3uplay.com/user-static/c8c6b450-f4f7-48a0-8f77-2bfe39a6d0633647890664831876505.png',
            true
          ),
          levelGift(
            itemName('legend_throne'),
            12,
            'https://resource.3uplay.com/user-static/32b54587-3132-4fe2-b395-dc0bec0033eb3991062369174230640.png',
            true
          ),
          exclusiveFrame(
            itemName('legend_dragon'),
            itemName('legend_throne'),
            'https://resource.funplus.social/sys-feed/b05854d9-e91a-46f8-a6dd-9ccbad30dc4f7397840883905391607.webp'
          ),
          beautifulId(5)
        ],
        contents: [needPoints(888888)]
      },
      {
        level: 15,
        levelName: 'VIP15',
        list: [
          coupon(10, 200, require('@/pages/vip-center/images/vouchers20010.png')),
          diamonds(100000),
          avatarFrame(
            itemName('eternal_legend'),
            'https://resource.funplus.social/sys-feed/2e9fb8f7-4afb-4392-a734-b51f884da9077328833523230148633.webp'
          ),
          mount(
            itemName('manifest_world'),
            'https://resource.funplus.social/user-static/155f1f37-b1c7-45dc-ac5f-7ccd6d722af81325340255550521669.png',
            true,
            true
          ),
          mount(
            itemName('nirvana'),
            'https://resource.funplus.social/user-static/63c74b27-5672-48ec-b900-927b700de8db3983784119880237444.png',
            true,
            true
          ),
          beautifulId(4)
        ],
        contents: [needPoints(1688888)]
      }
    ];
  }
}

/**
 * @description: 音色類型
 * @return {*}
 */
export function getVoiceType(sex) {
  const obj = {
    femaleList: [
      '女王音',
      '御媽音',
      '御姐音',
      '少御偏御音',
      '溫御音',
      '少御音',
      '少女音',
      '蘿莉音',
      '少蘿音',
      '甜妹音',
      '學妹音'
    ],
    maleList: [
      '帝王音',
      '正太音',
      '青年音',
      '青叔音',
      '青年音',
      '青叔音',
      '公子音',
      '大叔音',
      '青攻音',
      '青年音',
      '暖男音'
    ]
  };
  if (sex === 'female') {
    return obj.femaleList;
  }
  if (sex === 'male') {
    return obj.maleList;
  }
  return obj;
}
